module.exports = __webpack_public_path__ + "static/media/TurkeyJake.svg";